<template>
  <div class="agent-subOnline-page">
    <div class="head_area">
      <div class="leftImg">
        <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
      </div>
      <span class="head_text">下级在线</span>
      <span class="right_menu"></span>
    </div>
    <div class="search-box">
      <div class="search-item">
        <div class="input-box">
          <img src="/static/image/new/agent/search-icon.png" class="icon" alt="">
          <input type="text" placeholder="输入账号" v-model="params.search">
        </div>
        <div class="search-btn" @click="initData()">搜索</div>
      </div>
      <div class="search-item">
        <div class="select-box"></div>
        <div class="switch-box">
          <div class="switch-item">
            <div class="label">在线</div>
            <div class="value">
              <van-switch size="20px" @change="initData()" v-model="params.online_only" inactive-color="#dcdee0"/>
            </div>
          </div>
          <div class="switch-item">
            <div class="label">直属</div>
            <div class="value">
              <van-switch size="20px" @change="initData()"  v-model="params.direct_only" inactive-color="#dcdee0"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
        <div class="table-box">
          <div class="table-head">
            <div class="td">ID</div>
            <div class="td">昵称</div>
            <div class="td">所在房间</div>
          </div>
          <div class="table-content">
            <template v-if="list.length > 0">
              <div class="tr" v-for="(item, index) in list">
                <div class="td">
                  <div class="user-id">{{item.id}}</div>
                </div>
                <div class="td">
                  <span class="agent-text">(代理)</span>
                  {{item.name}}
                </div>
                <div class="td">
                  <div class="game-type">{{item.room.split('-')[0] || ''}}</div>
                  <div class="room-type">{{item.room.split('-')[1] || ''}}</div>
                </div>
              </div>
            </template>
            <div v-else class="table-empy">暂无数据</div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import {translateText, getCurrentDay, formatDate} from "../../common/utils";
import subAgent from "./subAgent.vue";

export default {
  name: 'agent-info',
  computed: {
    subAgent() {
      return subAgent
    }
  },
  data(){
    return {
      params: {
        online_only: false,   // 1=只显示在线用户，0=显示所有
        direct_only: false,    // 1=只显示直属下级（pid=当前用户ID），0=显示所有团队（包含下级的下级）
        search: '',    // 搜索账户
        pageSize: 10,    // 每页条数
        page:   1
      },
      total: 0,

      loading: false,
      list: [],
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    back(){
      window.history.go(-1)
    },
    initData() {
      this.params.page = 1
      this.list = []
      this.total = 0
      this.getList()
    },
    async showTost(type, title) {
      // const message = await translateText([title]);
      this.$parent.showTost(type, title);
    },
    getList(){
      this.loading = true
      this.$apiFun
        .post('/api/game/getOnlineUserList', {
          ...this.params,
          online_only: Number(this.params.online_only),
          direct_only: Number(this.params.direct_only),
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.message);
          }
          if (res.code === 200) {
            this.total = res.data.data.pagination.total

            if(this.params.page === 1) {
              this.list = res.data.data.list;
            }else {
              this.list = [...this.list, ...res.data.data.list];
            }
            this.params.page++;
          }
          this.loading = false
        })
        .catch(res => {
          this.loading = false
        });
    }

  },
}
</script>


<style scoped lang="scss">
.van-switch--on {
  background: linear-gradient( 180deg, #02BAEE 0%, #0B78FC 100%) !important;
}
.agent-subOnline-page {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction:column;
  overflow: hidden;
  background: #F1F1F1;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    background: linear-gradient( 90deg, #3A8AFF 0%, #89AAFF 100%);
    .leftImg {
      flex: 1;
      text-align: right;
      transform: rotate(180deg);
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.43rem;
      font-weight: bold;
      font-family: PingFang SC;
      color: #fff;
      width: 80%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      font-family: PingFang SC;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .search-box {
    padding: 0.24rem .36rem 0;
    .search-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.24rem;
      .select-time-box {
        width: 3.6rem;
        height: 0.77rem;
        background: #fff;
        border-radius: .5rem;
        padding: 0 0.27rem;
        font-size: 0.24rem;
        line-height: .35rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        .placeholder {
          color: #999999;
        }
      }
      .line {
        margin: 0 .15rem;
      }
      .input-box {
        display: flex;
        align-items: center;
        padding: 0 0.3rem 0 0.5rem;
        background: #fff;
        height: 0.77rem;
        flex: 1;
        border-radius: .5rem;
        .icon {
          width: 0.44rem;
          margin-bottom: .02rem;
          margin-right: .2rem;
        }
        input {
          flex: 1;
          height: 100%;
          outline: none;
          background: transparent;
          border: none;
          font-size: 0.29rem;
          &::-webkit-input-placeholder {
            color: #999999;
          }
        }
      }
      .switch-box {
        display: flex;
        align-items: center;
        .switch-item {
          display: flex;
          align-items: center;
          margin-left: .48rem;
          .label {
            font-size: 0.29rem;
            color: #666666;
            margin-right: .19rem;
          }
        }
      }
      .search-btn {
        flex-shrink: 0;
        height: 0.75rem;
        line-height: 0.75rem;
        padding: 0 .19rem;
        background: linear-gradient( 90deg, #02BCEE 0%, #0B76FD 100%);
        border-radius: .37rem;
        font-size: 0.24rem;
        color: #fff;
        margin-left: .14rem;
        min-width: 1rem;
        text-align: center;
      }
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    position: relative;
    z-index: 2;
    padding: .24rem .36rem;
    .table-box {
      .table-head {
        height: 0.89rem;
        background: linear-gradient( 91deg, #03B5EF 0%, #0B7AFC 100%);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top-left-radius: .22rem;
        border-top-right-radius: .22rem;
        font-size: 0.29rem;
        padding: 0 .65rem;
        .td {
          max-width: calc(100% / 3);
          text-align: center;
        }
      }
      .table-content {
        background: #fff;
        .table-empy {
          width: 100%;
          height: 1.21rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #666;
          font-size: 0.29rem;
        }
        .tr {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 .24rem;
          height: 1.21rem;
          &:nth-child(even) {
            background: #F1FCFF;
          }
          .td {
            max-width: calc(100% / 3);
            min-width: 22%;
            text-align: center;
            font-size: 0.24rem;
            &:first-child {
              text-align: left;
            }
          }
          .user-id {
            padding-left: .26rem;
            position: relative;
            &::after {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 0.1rem;
              height: 0.1rem;
              background: #00AF4D;
              border-radius: 50%;
            }
          }
          .agent-text {
            color: #0B78FD;
            font-size: 0.24rem;
            margin-right: .04rem;
          }
          .game-type {
            color: #0B78FD;
            font-size: 0.29rem;
          }
          .room-type {
            font-size: 0.29rem;
            margin-top: .1rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agent/subOnline.vue